const Loader = ({ theme }) => <div className={theme ? `loader ${theme}` : "loader"} aria-hidden={true}></div>;

export default Loader;
